/*Customer Management*/ 
import { ApiService } from "./api.service";
import { downloadFile } from "../_helpers/downloadFile"
import axios from 'axios'
import moment from 'moment'
export const CMService = {
    fetchCustomer,
    fetchCustomerList,
    customerCreate,
    customerUpdate,
    customerDelete,
    customerRemoveTemp,
    customerTypeGet,
    customerTypeGetList,
    customerTypeGetOrCreate,
    customerTypeUpdate,
    customerTypeDelete,
    customersDownloadExcel,
    promotionCustomerGetList,
    promotionCustomerCreate,
    promotionCustomerUpdate,
    promotionCustomerDelete,
    fetchSalePersonList,
    salePersonGetOrCreate,
    salePersonUpdate,
    salePersonDelete,
    fetchSaleOrderSetupList,
    saleOrderSetupGetOrCreate,
    saleOrderSetupGet,
    saleOrderSetupUpdate,
    saleOrderSetupDelete,
    saleOrderPromotionConfirm,
    postSaleTrans,
    saleOrderTransferring,
    saleOrderCancelling,
    fetchDocumentNumber,
    fetchOrderCustomer,
    fetchSaleDefaults,
    getOrCreateSLTransaction,
    saveOpenMasterTrans,
    saveOpenMasterDiscount,
    updateSLTransaction,
    updateOrderCustomer,
    updateSLCurrency,
    deleteSLTransacion,
    createSLItem,
    createSLItems,
    updateSLItem,
    deleteSLItem,
    saleOpenLotItemGetList,
    saleOpenLotItemPost,
    saleOpenLotItemDelete,
    saleOpenLotAssign,
    saleOpenLotUpdateAssign,
    fetchSLTransactionItems,
    fetchSLTransactionItemsInnerProduct,
    fetchSLReturnTransactionXSLReport,
    fetchSODGet,
    fetchSOM,
    fetchSLTransaction,
    fetch_SOM_list,
    saleHistoReport,
    saleBackOrderOpen,
    saleOpenPickingList,
    saleOpenPickingListGeneral,
    fetchSLHistoryTransactionHead,
    fetchSLHistoryTransactionItems,
    fetchSLHistoryTransactionsHead,
    downloadInvoicingHistorySummary,
    downloadInvoicingHistoryDetail,
    downloadOpenReturnSaleTransaction,
    orderDeliveryMethodGetOrCreate,
    orderDeliveryMethodEdit,
    orderDeliveryMethodGet,
    orderDeliveryMethodList,
    orderDeliveryMethodDelete,
    salePromotionMasterGetOrCreate,
    salePromotionMasterEdit,
    salePromotionMasterGet,
    salePromotionMasterList,
    salePromotionMasterDelete,
    salePromotionDetailCreate,
    salePromotionDetailGetList,
    salePromotionDetailDelete,
}


/* Customer */
function fetchCustomer(customerCode) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.get(`/cm/card/customer?customerCode=${customerCode}`);
}

function fetchCustomerList(query, col, page, limit) {
    //      /*
    //    * Fetch all customer with limit 25
    //    *
    //    * @returns array
    //    **/
    return ApiService.get(`/cm/card/customer-list?query=${query}&col=${col}&page=${page}&limit=${limit}`);
}

function customerCreate(customerCode) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post('/cm/card/customer', {customerCode})
}

function customerUpdate(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put('/cm/card/customer/',data)
}

function customerDelete(id)  {
    //   /**
    //    * @returns object deleted
    //    **/
    return ApiService.delete(`/cm/card/customer/${id}`)
}

function customerRemoveTemp (id) {
    //   /**
    //    * @returns object removed
    //    **/
    return ApiService.delete(`/cm/card/customer/tmp/${id}`)
}

function customerTypeGet(customerTypeCode) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.get(`/cm/card/customer-type-master?customerTypeCode=${customerTypeCode}`);
}

function customerTypeGetList(q, page) {
    //      /*
    //    * Fetch all customer with limit 25
    //    *
    //    * @returns array
    //    **/
    return ApiService.get(`/cm/card/customer-type-master/list`);
}

function customerTypeGetOrCreate(customerTypeCode) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post('/cm/card/customer-type-master/', {customerTypeCode})
}

function customerTypeUpdate(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put('/cm/card/customer-type-master/',data)
}

function customerTypeDelete(id)  {
    //   /**
    //    * @returns object deleted
    //    **/
    return ApiService.delete(`/cm/card/customer-type-master/${id}`)
}
function customersDownloadExcel()  {
    const filename = 'Reporte de clientes'
    axios({
        url: `/cm/reports/customers/downloadExcel/`,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => downloadFile(response, `${filename}.xlsx`));
    }


function fetchSalePersonList(q, page) {
    //      /*
    //    * Fetch all customer with limit 25
    //    *
    //    * @returns array
    //    **/
    return ApiService.get(`/cm/sale-person/list?q=${q}&page=${page}`);
}

function salePersonGetOrCreate(salePersonCode) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post('/cm/sale-person/r/c', {salePersonCode})
}

function salePersonUpdate(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put('/cm/sale-person/',data)
}

function salePersonDelete(id)  {
    //   /**
    //    * @returns object deleted
    //    **/
    return ApiService.delete(`/cm/sale-person/${id}`)
}

function fetchSaleOrderSetupList(orderType) {
    //      /*
    //    * Fetch all customer with limit 25
    //    *
    //    * @returns array
    //    **/
    return ApiService.get(`/cm/sale/config/documents/${orderType}`);
}

function saleOrderSetupGetOrCreate(orderType, documentCode) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post('/cm/sale/config/document/', {orderType, documentCode})
}

function saleOrderSetupGet(orderType, documentCode) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post('/cm/sale/config/getDocumentSetup/', {orderType, documentCode})
}

function saleOrderSetupUpdate(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put('/cm/sale/config/document/',data)
}

function saleOrderSetupDelete(id)  {
    //   /**
    //    * @returns object deleted
    //    **/
    return ApiService.delete(`/cm/sale/config/document/${id}`)
}



function postSaleTrans (id) {
    //   /**
    //    * @returns object removed
    //    **/ 
    return ApiService.post('/cm/sale/post-transaction',{id})
}



function saleOrderPromotionConfirm(data) {
    return ApiService.post('/cm//sale/promotion-confirm', data)
}

function saleOrderTransferring (id, toOrderType) {
    //   /**
    //    * @returns object removed
    //    **/ 
    return ApiService.post('/cm/sale/transfer-transaction',{id, toOrderType})
}

function saleOrderCancelling (id) {
    //   /**
    //    * @returns object removed
    //    **/ 
    return ApiService.post('/cm/sale/cancel-transaction',{id})
}

function fetchDocumentNumber (orderType) {
    //   /**
    //    * @returns object
    //    **/ 
    return ApiService.post('/cm/sale/fetch-doc-num',{orderType})
}

function fetchOrderCustomer (id) {
    return ApiService.get(`/cm/sale/customer/${id}`)
}

function fetchSaleDefaults () {
    return ApiService.get(`/cm/sale/defaults/`)

}

function getOrCreateSLTransaction (orderType, documentCode, orderNumber) {
    //   /**
    //    * @returns object
    //    **/ 
    return ApiService.post('/cm/sale/transaction', {orderType, documentCode, orderNumber })
}

function deleteSLTransacion (id) {
    //   /**
    //    * @returns object
    //    **/
    
    return ApiService.delete(`/cm/sale/transaction/${id}`)
}

function createSLItem (data) {
    //   /**
    //    * @returns object
    //    **/
    
    return ApiService.post('/cm/sale/product/', data)
}

function createSLItems(data) {
    return ApiService.put(`/cm/sale/transaction/copyDetailLines`, data)
}

function updateSLItem (data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put('/cm/sale/product/', data)
}

function deleteSLItem (id) {
    //   /**
    //    * @returns object
    //    **/
    
    return ApiService.delete(`/cm/sale/product/${id}`)
}

function fetchSODGet(id) {
    return ApiService.get(`/cm/sale/open/detail/${id}`)
}

function fetchSLTransactionItems(orderType, orderNumber, page=0, limit=25) {
    //   /**
    //    * @returns array
    //    **/ 
    return ApiService.get(`/cm/sale/d/open-transaction/${orderType}/${orderNumber}?page=${page}&limit=${limit}`)
}

function saleBackOrderOpen(format, page, limit) {
    let url = `/cm/sale/report/getOpenBackOrdersItem?format=${format}`
    if (format === 'xls') {
        axios({
            url,
            method: 'GET',
            responseType: 'blob', 
          }).then((response) => downloadFile(response, `pedido en espera.xlsx`));
    } else {
        return ApiService.get(`${url}&page=${page}&limit=${limit}`)
    }
    
}

function saleOpenPickingList(orderNumber, format = '', page = 0, limit = 999) {
    let url = `/cm/sale/report/getOpenPickingList?orderNumber=${orderNumber}&format=${format}`
    if (format === 'xls') {
        axios({
            url,
            method: 'GET',
            responseType: 'blob', 
          }).then((response) => downloadFile(response, `${orderNumber}-picking list.xlsx`));
    } else {
        return ApiService.get(`${url}&page=${page}&limit=${limit}`)
    }
    
}

function saleOpenPickingListGeneral(filters = null, format = '', page = 0, limit = 999) {
    let url = `/cm/sale/report/getOpenPickingListGeneral`
    let data = {filters, format}
    if (format === 'xls') {
        axios({
            url,
            method: 'POST',
            responseType: 'blob', 
            data,
          }).then((response) => downloadFile(response, `picking list.xlsx`));
    } else {
        return ApiService.post(`${url}?page=${page}&limit=${limit}`, data)
    }
    
}



function fetchSLTransactionItemsInnerProduct(orderType, orderNumber, page=0) {
    //   /**
    //    * @returns array
    //    **/ 
    return ApiService.post(`/cm/sale/report/getOpenInvoiceItems/`, { orderType, orderNumber })
}

function fetchSLReturnTransactionXSLReport(orderNumber) {
    //   /**
    //    * @returns array
    //    **/ 
    return ApiService.post(`/cm/sale/report/return-open-detail/`, { orderNumber })
}

function fetchSOM(orderType, orderNumber) {
    //   /**
    //    * @returns array
    //    **/ 
    return ApiService.get(`/cm/sale/m/open-transaction/${orderType}/${orderNumber}`)
}
function fetchSLTransaction(id) {
    return ApiService.get(`/cm/sale/transaction/${id}`)

}

function fetchSLHistoryTransactionHead (orderType, orderNumber) {
    return ApiService.get(`/cm/sale/transaction-head?orderType=${orderType}&orderNumber=${orderNumber}`)

}

function fetchSLHistoryTransactionItems(orderType, orderNumber, ) {
    //   /**
    //    * @returns array
    //    **/ 
    return ApiService.get(`/cm/sale/transaction-detail-history?orderType=${orderType}&orderNumber=${orderNumber}`)
}

function fetchSLHistoryTransactionsHead(orderType, customerCode, orderNumber, fromDate, toDate, page, limit) {
    //   /**
    //    * @returns array
    //    **/ 
    return ApiService.get(`/cm/sale/transactions-head-history?orderType=${orderType}&customerCode=${customerCode}&orderNumber=${orderNumber}&fromDate=${fromDate}&toDate=${toDate}&page=${page}&limit=${limit}`)
}


function saleOpenLotItemGetList(order_type, order_number, line_seq) {
    return ApiService.get(`/cm/sale/transaction/open/item/lot/${order_type}/${order_number}/${line_seq}`);
}
function saleOpenLotItemPost(data) {
    return ApiService.post(`/cm/sale/transaction/open/item/lot/`, data);
}
function saleOpenLotItemDelete(id) {
    return ApiService.delete(`/cm/sale/transaction/open/item/lot/${id}`);
}
function saleOpenLotAssign(id, id_lot) {
    return ApiService.post(`/cm/sale/transaction/open/item/lot-assignment/`, {id, id_lot})
}
function saleOpenLotUpdateAssign(id, lot_qty) {
    return ApiService.put(`/cm/sale/transaction/open/item/lot-assignment/`, {id, lot_qty})
}

function updateOrderCustomer(data) {
    return ApiService.put('/cm/sale/transaction/customer', data)
}

function saveOpenMasterTrans(data) {
    //   /**
    //    * @returns object
    //    **/ 
    return ApiService.put('/cm/sale/transaction',data)
}

function saveOpenMasterDiscount(data) {
    //   /**
    //    * @returns object
    //    **/ 
    return ApiService.put('/cm/sale/discount',data)
}

function updateSLTransaction(data) {
    return ApiService.post('/cm/sale/transaction/customer', data)
}


function updateSLCurrency(data) {
    //   /**
    //    * @returns object
    //    **/ 
    return ApiService.put('/cm/sale/transaction/currency',data)
}

function fetch_SOM_list(orderType, documentCode, page, limit){
     //   /**
    //    * @returns array
    //    **/ 
    return ApiService.get(`/cm/sale/m/list/open-transactions?order_type=${orderType}&document_code=${documentCode}&page=${page}&limit=${limit}`)
}



function saleHistoReport (orderType, date1, date2, page, limit) {
    //   /**
    //    * @returns array
    //    **/ 
    return ApiService.post(`/cm/sale/report/posted-transactions?date1=${date1}&date2=${date2}&orderType=${orderType}&page=${page}&limit=${limit}`)
}

function downloadInvoicingHistorySummary(date1, date2, document_code) { 
    let filename = 'Histórico de facturas - Resumen'

    axios({
        url: `/cm/reports/sales/downloadInvoicingHistorySummary?date1=${date1}&date2=${date2}&documentCode=${document_code}`,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => downloadFile(response, `${filename}.xlsx`));

    }



function downloadInvoicingHistoryDetail(date1, date2, customerCode, documentNumber) {
    let filename = 'Histórico de facturas - Detallado'
    axios({
        url: `/cm/reports/sales/downloadInvoicingHistoryDetail?date1=${date1}&date2=${date2}&customerCode=${customerCode}&documentNumber=${documentNumber}`,
        method: 'GET',
        responseType: 'blob', // important
      }).then((response) => downloadFile(response, `${filename}.xlsx`));

}
function downloadOpenReturnSaleTransaction(orderNumber) {
    return axios({
        url:'/cm/sale/report/return-open-detail',
        data: { orderNumber},
        method: 'POST',
        responseType: 'blob'
    })
    .then(response => downloadFile(response, `${orderNumber}.xlsx`))
}
function orderDeliveryMethodGetOrCreate(delivery_method_code){
    return ApiService.post(`/cm/sale/config/order-delivery-method/r/c/`, { delivery_method_code })
}

function orderDeliveryMethodEdit(data){
    return ApiService.put(`/cm/sale/config/order-delivery-method/`, data)
}

function orderDeliveryMethodGet(delivery_method_code){
    return ApiService.get(`/cm/sale/config/order-delivery-method/${delivery_method_code}`)
}

function orderDeliveryMethodList(query, page){
    return ApiService.get(`/cm/sale/config/order-delivery-method-list?page=${page}`)
}

function orderDeliveryMethodDelete(id) {
    return ApiService.delete(`/cm/sale/config/order-delivery-method/${id}`)
}

function salePromotionMasterGetOrCreate(promotionCode){
    return ApiService.post(`/cm/sale/config/sale-promotion`, { promotionCode })
}

function salePromotionMasterEdit(data){
    return ApiService.put(`/cm/sale/config/sale-promotion/`, data)
}

function salePromotionMasterGet(delivery_methpromotion_codeod_code){
    return ApiService.get(`/cm/sale/config/sale-promotion/${promotion_code}`)
}

function salePromotionMasterList(query, page){
    return ApiService.get(`/cm/sale/config/sale-promotions?page=${page}`)
}

function salePromotionMasterDelete(id) {
    return ApiService.delete(`/cm/sale/config/sale-promotion/${id}`)
}

function salePromotionDetailCreate(data){
    return ApiService.post(`/cm/sale/config/sale-promotion-detail`, data)
}

function salePromotionDetailGetList(promotionCode, page){
    return ApiService.get(`/cm/sale/config/sale-promotion-details?promotionCode=${promotionCode}&page=${page}`)
}

function salePromotionDetailDelete(id) {
    return ApiService.delete(`/cm/sale/config/sale-promotion-detail/${id}`)
}

function promotionCustomerGetList(promotionCode) {
    //      /*
    //    * Fetch all customer with limit 25
    //    *
    //    * @returns array
    //    **/
    return ApiService.get(`/cm/config/promotion-customer/list?promotionCode=${promotionCode}`);
}

function promotionCustomerCreate(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.post('/cm/config/promotion-customer/', data)
}

function promotionCustomerUpdate(data) {
    //   /**
    //    * @returns object
    //    **/
    return ApiService.put('/cm/config/promotion-customer/',data)
}

function promotionCustomerDelete(id)  {
    //   /**
    //    * @returns object deleted
    //    **/
    return ApiService.delete(`/cm/config/promotion-customer/${id}`)
}




// WEBPACK FOOTER //
// ./src/services/cm.service.js